import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';

export interface CheckboxWithTextCSSStyle extends UIComponentCSSStyle {
    getCSSStyleOne(): object;
    getCSSStyleTwo(): object;
    getCSSStyleThree(): object;
    getSelectedTextCSSStyle(): object;
    getUnSelectedTextCSSStyle(): object;
}

export class CheckboxWithTextCSSStyleImpl extends UIComponentCSSStyleImpl implements CheckboxWithTextCSSStyle {
    getWrapperCSSStyle(): object {
        return {
            display: "flex",
            flexFlow: "row wrap",
        };
    }

    getCSSStyleOne(): Object {
        return {
            position: 'relative',
            height: '18px',
            width: "18px",
            float: "left",
            marginTop: "2px",
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_2),
            borderRadius: '18px'
        };
    }
    getCSSStyleTwo(): Object {
        return {
            position: 'absolute', height: '4px',
            width: '9px', top: '6px', left: '5px',
            borderLeft: 'solid 2px ' + this.getResources().getColor(Colors.color_5),
            borderBottom: 'solid 2px ' + this.getResources().getColor(Colors.color_5),
            borderRadius: '0px',
            cursor: "pointer",
            transform: 'rotate(-45deg)'
        };
    }

    getCSSStyleThree(): Object {
        return {
            position: 'relative',
            height: '18px',
            width: "18px",
            borderRadius: '18px',
            float: "left",
            marginTop: "2px",
            cursor: "pointer",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            border: "solid 1px" + this.getResources().getColor(Colors.color_8)
        };
    }

    getSelectedTextCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h9),
            color: "#999999",
            height: "20px",
            fontWeight: 500,
            letterSpacing: 0,
            paddingLeft: "10px",
            paddingRight: "10px",
            lineHeight: "20px",
            outline: "none"
        };
    }
    getUnSelectedTextCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h9),
            color: this.getResources().getColor(Colors.color_36),
            height: "20px",
            fontWeight: 500,
            letterSpacing: 0,
            paddingLeft: "10px",
            paddingRight: "10px",
            lineHeight: "20px",
            outline: "none"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/checkboxwithtext/checkboxwithtextcss.tsx